<template>
  <common-export-validation
    :fileType="fileMeta.type"
    :fileDate="fileMeta.date"
    :feedback="feedback"
    :content="transformed"
  ></common-export-validation>
</template>

<script>
import CommonExportValidation from "./CommonExportValidationTemplate";
import { QualipoolDtaVkaMapper } from "../../../../../plugins/DmeExport/QualipoolDtaVkaMapper";

export default {
  name: "QualipoolExportValidation",
  components: { CommonExportValidation },
  props: {
    content: {
      type: Object,
      default: function() {
        return {};
      }
    },
    feedback: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    fileMeta() {
      const meta = this.content?.["VkaDocument"]?.[0] ?? {};
      return {
        type: `Qualipool - ${meta.InterfaceName} - ${meta.InterfaceVersion}`,
        date: meta.ResponseDate
      };
    },
    transformed() {
      return QualipoolDtaVkaMapper.apply(this.content);
    }
  }
};
</script>
